module.exports = __webpack_public_path__ + "img/banner-en.2e1f2fdc.png";